import React, { useEffect, useMemo } from 'react';

// In-app viewer for the generated contract (MSA + Order Form + BAA).
// Renders the PDF in an iframe overlay — the browser's native PDF viewer
// handles paging/zoom. The URL gets a timestamp param so a quote edited via
// the builder always re-renders fresh (the API serves it no-store).
const ContractViewer = ({ url, title, onClose }) => {
  // Freeze the cache-buster for this open so the iframe doesn't reload on re-renders
  const src = useMemo(() => `${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}`, [url]);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(15, 23, 42, 0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 12, overflow: 'hidden',
          width: 'min(960px, 96vw)', height: '92vh',
          display: 'flex', flexDirection: 'column',
          boxShadow: '0 24px 60px rgba(0,0,0,0.35)',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: '12px 16px', background: '#0B4426',
        }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {title || 'Contract'}
            </div>
            <div style={{ fontSize: 11, color: '#cfe3d6' }}>MSA + Order Form + BAA — draft, renders from the saved quote</div>
          </div>
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '7px 14px', fontSize: 12, fontWeight: 600, borderRadius: 6,
              background: 'rgba(255,255,255,0.12)', color: '#fff', textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.35)', whiteSpace: 'nowrap',
            }}
          >
            Open in New Tab
          </a>
          <a
            href={`${url}${url.includes('?') ? '&' : '?'}download=1`}
            style={{
              padding: '7px 14px', fontSize: 12, fontWeight: 600, borderRadius: 6,
              background: 'rgba(255,255,255,0.12)', color: '#fff', textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.35)', whiteSpace: 'nowrap',
            }}
          >
            Download
          </a>
          <button
            onClick={onClose}
            style={{
              padding: '7px 14px', fontSize: 12, fontWeight: 700, borderRadius: 6,
              background: '#fff', color: '#0B4426', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Close
          </button>
        </div>
        {/* PDF */}
        <iframe
          title={title || 'Contract PDF'}
          src={src}
          style={{ flex: 1, border: 'none', width: '100%', background: '#525659' }}
        />
      </div>
    </div>
  );
};

export default ContractViewer;
